// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LocationBridgeController from "./bridge/location_bridge_controller"
application.register("bridge--location", LocationBridgeController)

import ExpandImageController from "./expand_image_controller"
application.register("expand-image", ExpandImageController)

import DjambiController from "./djambi_controller"
application.register("djambi", DjambiController)

import DescriptionLoaderController from "./description_loader_controller"
application.register("description-loader", DescriptionLoaderController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InitialMapController from "./initial_map_controller"
application.register("initial-map", InitialMapController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapController from "./map_controller"
application.register("map", MapController)

import MapboxAutocompleteController from "./mapbox_autocomplete_controller"
application.register("mapbox-autocomplete", MapboxAutocompleteController)

import PoiReorderController from "./poi_reorder_controller"
application.register("poi-reorder", PoiReorderController)

import PoiDisplayController from "./poi_display_controller"
application.register("poi-display", PoiDisplayController)

import PropertyListingsMapController from "./property_listings_map_controller"
application.register("property-listings-map", PropertyListingsMapController)

import PropertyListingMapController from "./property_listing_map_controller"
application.register("property-listing-map", PropertyListingMapController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import WorkItemsController from "./work_items_controller"
application.register("work-items", WorkItemsController)

import ParticipantPickerController from "./participant_picker_controller"
application.register("participant-picker", ParticipantPickerController)

import TtsController from "./tts_controller"
application.register("tts", TtsController)
